import React, { useEffect, useState } from 'react';
import { API_ENDPOINTS } from '../../utils/endpoints';
import { useDispatch, useSelector } from 'react-redux';
import {
    getOnboardingData,
    setOnboardingData
} from '../../../../redux/onboardingSlice';
import { http_put } from '../../utils/api_client';

const OPTIONS = ['Just me', '2–10', '11–50', '51–200', '200+'];

export const CompanySizeTitle = () => (
    <div>
        <h1 className="un-auth__q">How big is your team?</h1>
        <p className="un-auth__sub">We'll tailor recommendations to your size.</p>
    </div>
);

const CompanySize = ({ onChangeStep }) => {
    const dispatch = useDispatch();
    const data = useSelector((state) => getOnboardingData(state));
    const [isLoading, setIsLoading] = useState(false);
    const [isDisabled, setIsDisabled] = useState(true);
    const [error, setError] = useState(null);

    const saveData = () => {
        setIsLoading(true);
        setError(null);
        http_put(API_ENDPOINTS.PUT_COMPANY, { company_size: data.companySize })
            .then(() => onChangeStep())
            .catch((err) => {
                setError(err?.response?.data?.error || err?.response?.data?.message || 'Something went wrong. Please try again.');
            })
            .finally(() => setIsLoading(false));
    };

    const select = (value) => {
        dispatch(setOnboardingData({ companySize: value }));
    };

    useEffect(() => {
        setIsDisabled(!data.companySize);
    }, [data]);

    return (
        <>
            <div className="un-auth__pills">
                {OPTIONS.map((option) => (
                    <button
                        key={option}
                        type="button"
                        className={`un-auth__pill ${data.companySize === option ? 'sel' : ''}`}
                        onClick={() => select(option)}
                    >
                        {option}
                    </button>
                ))}
            </div>
            {error && <p className="un-auth__err" role="alert">{error}</p>}
            <button className="un-auth__btn un-auth__btn--primary" onClick={saveData} disabled={isDisabled || isLoading}>
                {isLoading ? 'Saving…' : 'Continue'}
            </button>
        </>
    );
};

export default CompanySize;
